import React from 'react';
import { DirectionToggle } from '../shared/DirectionToggle';
import { TickSelector } from '../shared/TickSelector';

interface EvenOddParamsProps {
  direction: 'even' | 'odd';
  tickCount: number;
  onDirectionChange: (direction: 'even' | 'odd') => void;
  onTickCountChange: (count: number) => void;
}

const EvenOddParams: React.FC<EvenOddParamsProps> = ({
  direction,
  tickCount,
  onDirectionChange,
  onTickCountChange
}) => {
  return (
    <>
      <div className="parameter-group">
        <label>Direction</label>
        <DirectionToggle
          leftLabel="Even"
          rightLabel="Odd"
          selectedDirection={direction}
          onDirectionChange={(dir) => onDirectionChange(dir as 'even' | 'odd')}
        />
      </div>

      <div className="parameter-group">
        <label>Examples</label>
        <div className="digit-examples">
          <div className="example-group">
            <span className="example-label">Even:</span>
            <span className="example-digits">0, 2, 4, 6, 8</span>
          </div>
          <div className="example-group">
            <span className="example-label">Odd:</span>
            <span className="example-digits">1, 3, 5, 7, 9</span>
          </div>
        </div>
      </div>

      <div className="parameter-group">
        <label>Tick Count</label>
        <TickSelector
          tickCount={tickCount}
          onTickCountChange={onTickCountChange}
        />
      </div>
    </>
  );
};

export default EvenOddParams;
export { EvenOddParams };
